import { connect } from "react-redux";

import { showAlert } from "rivals/redux/alert/actions";
import { sendGAEvent } from "rivals/redux/ga/actions";
import { getPromotion } from "rivals/redux/promotion/selectors";
import {
  getSelectedSite,
  getSubscriptionPricingConstants
} from "rivals/redux/rails/selectors";
import { State } from "rivals/redux/reducer";
import { createSubscription } from "rivals/redux/subscription/actions";
import {
  getAddress,
  getCurrentUserPaypalEmail,
  getSubmitting,
  getUserSubscriptions
} from "rivals/redux/user/selectors";
import { DispatchProps, StateProps } from "./types";
import SubscriptionNew from ".";

const mapStateToProps = (state: State): StateProps => ({
  address: getAddress(state),
  payPalEmail: getCurrentUserPaypalEmail(state),
  promotion: getPromotion(state),
  railsConstants: getSubscriptionPricingConstants(state),
  selectedSite: getSelectedSite(state),
  submitting: getSubmitting(state),
  subscriptions: getUserSubscriptions(state)
});

const mapDispatchToProps: DispatchProps = {
  createSubscription,
  sendGAEvent,
  showAlert
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionNew);
